import { render, staticRenderFns } from "./LockDialog.vue?vue&type=template&id=6fd850c2&scoped=true"
import script from "./LockDialog.vue?vue&type=script&lang=js"
export * from "./LockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd850c2",
  null
  
)

export default component.exports